const NAMESPACE = 'SESSION_COMMON' as const;

const TEST_NAME_MAX_CHAR_LENGTH = 255 as const;
const TEST_NAME_CHAR_BYTE_MAX_LENGTH = 3;

export default {
  NAMESPACE,
  TEST_NAME_CHAR_BYTE_MAX_LENGTH,
  TEST_NAME_MAX_CHAR_LENGTH,
};
